import React from 'react';

const CustomBadge = ({ text, onClick, size = 'medium' }) => {
  return (
    <div
      className={`flex items-center gap-2 border border-solid border-inactive-text rounded-full  px-2 leading-5 ${
        size === 'small'
          ? 'text-xs h-7 text-inactive-text'
          : 'text-sm py-1 text-primary-text'
      }`}>
      <span>{text}</span>
      <button
        className="bg-transparent border-none text-border-gray-400 cursor-pointer text-lg font-bold p-0 hover:text-yellow-500"
        onClick={onClick}>
        ×
      </button>
    </div>
  );
};

export default CustomBadge;
